exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "textarea.consoleLog {\n  color: white;\n  background-color: black;\n  width: 100%;\n  font-family: monospace;\n  height: 600px !important;\n  font-size: 12px; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/ubuntu/edi/angular/app/views/console-applications/console-applications.component.scss
// module id = ../../../../../angular/app/views/console-applications/console-applications.component.scss
// module chunks = main